// objectStore의 이름을 정의한다.
// 여러 페이지에서 공유하므로 keyof typeof로 정의한다.
export const OBJECT_STORE_NAMES = {
  WORK_MANAGEMENT_INFO: "work-management-info"
} as const;

export type ObjectStoreKeys = keyof typeof OBJECT_STORE_NAMES;
